let language = {
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS: "Status",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS_AWAITING_IMPORT: "Awaiting Import",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS_INVALID_DATA: "Invalid Data",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS_IMPORT_FAILED: "Import Failed",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS_IMPORT_COMPLETE: "Import Complete",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATUS_VERIFICATION_SUCCESS: "Partial Import Successful",
    CRAFT_SHOP_ORDER_ITEMS_LIST_IMPORT_FILE: "Import File",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ORDER_NO: "Order No.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PRODUCT_ID: "Product ID",
    CRAFT_SHOP_ORDER_ITEMS_LIST_QUANTITY: "Quantity",
    CRAFT_SHOP_ORDER_ITEMS_LIST_OPERATION: "Operation",
    // 未知错误
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500006: "There is a missing or incorrect entry in one or more fields, please edit the order on the order page and retry.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500007: "There is a missing or incorrect entry in one or more fields, please edit the order on the order page and retry. ",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500008: "Invalid email address",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500009: "Invalid qty (must be greater than {{moq}})",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500010: "The store product does not exist, please check your product SKU. ",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500011: "The order has been successfully imported and is now complete. No further changes can be made to the details.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500013: "Duplicate store products detected in the same order. Please update the quantity for repeated items within the same order to proceed.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500014: "Invalid country.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500015: "Store product does not exist.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500016: "Duplicate order number.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500017: "The store product is not activated, please activate the product on My Product page.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500018: "The product does not belong to the current store. Please ensure that the item you are trying to order is part of the active store product catalog.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500019: "The product configuration in the store is incorrect.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500020: "The store product pricing configuration is incorrect.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500021: "This order has been successfully imported, but one or more items in the order failed to import. Please review the details and try again.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500022: "Currency conversion failure, If the problem persists, contact us at {{email}}.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500024: "The postal code you entered does not match the selected country or region.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500025: "State error",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_5500012: "Phone Number error",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000061: "Required field.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000071: "Field type error.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000081: "Invalid email address.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000091: "Invalid qty (must be greater than {{moq}}).",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000101: "The store product does not exist, please check your product SKU.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000111: "The order has been successfully imported and is now complete. No further changes can be made to the details.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000131: "Duplicate store products detected in the same order. Please update the quantity for repeated items within the same order to proceed.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000141: "Invalid country.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000151: "Store product does not exist.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000161: "Duplicate order number.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000171: "The store product is not activated, please activate the product on My Product page.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000181: "The product does not belong to the current store. Please ensure that the item you are trying to order is part of the active store product catalog.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000191: "The product configuration in the store is incorrect.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000201: "The store product pricing configuration is incorrect.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000211: "This order has been successfully imported, but one or more items in the order failed to import. Please review the details and try again.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000221: "Currency conversion failure, If the problem persists, contact us at {{email}}.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000241: "Postal Code check failure",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000251: "State error",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_55000121: "Phone Number error",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ERRORS_UNKNOWN_ERROR: "Unknown error.",

    CRAFT_SHOP_ORDER_ITEMS_LIST_EDIT_ORDER: "Edit Order",
    CRAFT_SHOP_ORDER_ITEMS_LIST_CREATE_NEW_ORDER: "Create New Order",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ORDER_INFORMATION: "Order Information:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ORDER_NUMBER: "Order Number:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ORDER_NUMBER_REQUIRED: "Order Number is required",
    CRAFT_SHOP_ORDER_ITEMS_LIST_DELIVERY_ADDRESS: "Delivery Address:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_FIRST_NAME: "First Name:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_FIRST_NAME_REQUIRED: "First Name is required.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_LAST_NAME: "Last Name:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_LAST_NAME_REQUIRED: "Last Name is required.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_COUNTRY_REGION: "Country/Region:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_COUNTRY_REQUIRED: "Country is required.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_EMAIL_ADDRESS: "Email Address:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_EMAIL_INVALID: "Invalid email address",
    CRAFT_SHOP_ORDER_ITEMS_LIST_EMAIL_REQUIRED: "Email Address is required.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATE_PROVINCE: "State/Province:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_STATE_REQUIRED: "State is required.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PHONE_NUMBER_1: "Phone Number 1:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PHONE_NUMBER_INVALID: "Please enter a valid number.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PHONE_NUMBER_REQUIRED: "Please enter phone number.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_CITY_TOWN: "City/Town:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_CITY_REQUIRED: "City is required.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_POSTAL_CODE: "Postal Code:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_POSTAL_CODE_REQUIRED: "Postal code is required.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_POSTAL_CODE_INVALID: "Please enter a valid postal code.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ADDRESS_1: "Address 1:",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ADDRESS_1_REQUIRED: "Address 1 is required.",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PRODUCT_ITEM: "Product Item",
    CRAFT_SHOP_ORDER_ITEMS_LIST_ADD_PRODUCT: "ADD PRODUCT",
    CRAFT_SHOP_ORDER_ITEMS_LIST_PRODUCT_ID_MODEL: "Product ID",
    CRAFT_SHOP_ORDER_ITEMS_LIST_QUANTITY_MODEL: "Quantity",
    CRAFT_SHOP_ORDER_ITEMS_LIST_UNIT_PRICE: "Unit Price",
    CRAFT_SHOP_ORDER_ITEMS_LIST_SUBTOTAL: "Subtotal",
    CRAFT_SHOP_ORDER_ITEMS_LIST_CANCEL: "CANCEL",
    CRAFT_SHOP_ORDER_ITEMS_LIST_SAVE: "SAVE",
    CRAFT_SHOP_ORDER_ITEMS_LIST_DELETE: "DELETE",
    CRAFT_SHOP_ORDER_ITEMS_LIST_DELETE_HINT_TITLE: "Delete Confirmation ",
    CRAFT_SHOP_ORDER_ITEMS_LIST_DELETE_HINT_CONTENT: "This action will permanently delete all order data, including imported items. Are you sure you want to proceed?",
    CRAFT_SHOP_ORDER_ITEMS_LIST_DELETE_HINT_CONTENT1: "Are you sure you want to delete this?",
    CRAFT_SHOP_ORDER_ITEMS_REVISE_THE_QUANTITY: "revise the quantity",
    CRAFT_SHOP_ORDER_ITEMS_QUANTITY: "quantity",
    CRAFT_SHOP_ORDER_ITEMS_SAVE_REEOR_TITLE: "Editing Error",
    CRAFT_SHOP_ORDER_ITEMS_SAVE_REEOR_CONTENT: "The order item cannot be empty",
    CRAFT_SHOP_ORDER_ITEMS_SAVE_REEOR_CONTENT_1500014: "Check address timeout",





};

export { language }